export default "__VITE_ASSET__DgDM23OZ__"